import React from 'react';
import styled from 'styled-components';
import Collapsible from 'react-collapsible';

import { Container, Row, Col, Paragraph, HeadingThree, Theme } from '../';

const data = [
  {
    question: 'How do I enable the hipages - Find a tradie skill?',
    answer:
      'Firstly ensure your Alexa enabled device is set up correctly and connected. Then open the Alexa app on your phone or go to <a href="//alexa.amazon.com.au" target="_blank" rel="noopener noreferrer" data-ga-category="Alexa Page" data-ga-action="FAQ" data-ga-label="Click Alexa Link"><strong>alexa.amazon.com.au</strong></a>. Tap Skills (To see the Skills option in the Alexa app, tap the hamburger menu) and search for "hipages". Select the <strong>hipages - Find a tradie</strong> skill to navigate to the skill\'s landing page then tap Enable. This will enable the skill on all Alexa enabled devices such as your Amazon Echo products. Once enabled, you can invoke the skill by saying one of the examples above.'
  },
  {
    question: 'Why do you need my phone number?',
    answer:
      'We aim to connect you directly with tradies so we need your phone number to pass it to the selected tradies.'
  },
  {
    question: 'Will I receive calls from tradies straight away?',
    answer:
      'No, first hipages will call you to clarify the details of your job. Once all the relevant details are complete, we then alert qualified tradies who service the desired suburb. If a tradie tells us they can help you, we pass them your details including your phone number so they can call you and arrange a quote.'
  },
  {
    question: "I don't want to receive calls from tradies, can I still use the skill?",
    answer:
      'Sure, when Alexa asks, "Do you want to receive phone calls from businesses who can help you?" Just say "No". In this scenario we\'ll send the details of three qualified tradies to the Alexa app on your phone and you can call the businesses whenever you want.'
  },
  {
    question: 'Is it a 24/7 service?',
    answer:
      "If you want tradies to call you directly then we will need to call you and clarify some details before alerting tradies. This can only happen when our offices are open. We're open Monday - Friday between 7am - 11pm and then 8am - 10pm on weekends. If you use the skill outside of these times and ask for tradies to call you, we'll call you as soon as we can when we open the next day."
  },
  {
    question: "I couldn't take the call when hipages rang, what do I do now?",
    answer:
      'That\'s fine. We\'ll try and contact you for two days. If after two days we still haven\'t managed to reach you then your job will be closed and archived. If you still need a tradie you will need to restart the process either with the <strong>hipages - Find a tradie</strong> skill or online at <a href="//hipages.com.au" target="_blank" rel="noopener noreferrer" data-ga-category="Alexa Page" data-ga-action="FAQ" data-ga-label="Click Hipages Link"><strong>hipages.com.au</strong></a>.'
  },
  {
    question: 'How do I know my job has been successfully submitted?',
    answer:
      'You will receive an SMS to the phone number you told Alexa. If you do not receive an SMS within five minutes then there may have been an issue with your job. In this scenario you would need to restart the process either with the <strong>hipages - Find a tradie</strong> skill or online at <a href="//hipages.com.au" target="_blank" rel="noopener noreferrer" data-ga-category="Alexa Page" data-ga-action="FAQ" data-ga-label="Click Hipages Link"><strong>hipages.com.au</strong></a>.'
  },
  {
    question: 'My Amazon Echo or Alexa enabled device is not working, what can I do?',
    answer:
      'For Amazon devices, contact Amazon Customer Service. For non Amazon devices, please contact the manufacturer.'
  }
];

const Accordion = styled.div`
  max-width: 800px;
  margin: 45px auto 0 auto;
  padding-bottom: 50px;

  .Collapsible {
    margin-bottom: 2px;
  }

  .Collapsible__contentInner {
    font-size: 15px;
    border-radius: 4px;
    margin-top: 2px;
    background: #fbfbfb;
    padding: 13px 20px 15px 20px;
    p {
      margin-top: 0;
      margin-bottom: 10px;
      line-height: 26px;

      &:last-child {
        margin-bottom: 0;
      }

      a {
        text-decoration: none;
        color: ${Theme.bodyFont};

        &:hover {
          color: ${Theme.primary};
        }
      }
    }
  }

  .Collapsible__trigger {
    border-radius: 4px;
    font-size: 15px;
    line-height: 26px;
    display: block;
    text-decoration: none;
    color: #2f3034;
    position: relative;
    padding: 13px 40px 10px 20px;
    background: #f5f5f6;

    &:after {
      font-family: 'hui-icons';
      content: '\f107';
      color: #7b7c7e;
      position: absolute;
      right: 20px;
      top: 13px;
      display: block;
      font-size: 21px;
      transition: transform 300ms;
    }

    &.is-open {
      &:after {
        transform: rotateZ(180deg);
      }

      background: #ececec;
    }

    &.is-disabled {
      opacity: 0.5;
      background-color: grey;
    }
  }
`;

// eslint-disable-next-line react/display-name
export default () => (
  <Container mt={3}>
    <Row>
      <Col xs={12}>
        <HeadingThree mt={0.25} style={{ fontWeight: 300, fontSize: '38px' }} center>
          Frequently asked questions
        </HeadingThree>
        <Paragraph style={{ fontSize: '15px' }} center>
          Need a hand with anything? Have a look at our answers below
        </Paragraph>
        <Accordion>
          {data.map((item, index) => {
            return (
              <Collapsible key={index} trigger={item.question}>
                <p dangerouslySetInnerHTML={{ __html: item.answer }} />
              </Collapsible>
            );
          })}
        </Accordion>
      </Col>
    </Row>
  </Container>
);
